<template>
  <router-view />
  <BaseNotifications />
  <TheCssBreakpointDetector />
</template>

<script setup lang="tsx">
import { BaseNotifications } from "@modernary/mui/components/notifications";
import { TheCssBreakpointDetector, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { routeNames } from "@/routes";
import LogoConnect from "@/components/LogoConnect.vue";

const appSettingsStore = useAppSettingsStore();
const { setNavigationItems, setApplicationTitleComponent, setSuiteLogoComponent } = useAppNav();

const titleComponent = () => <div>{appSettingsStore.applicationTitle}</div>;
setApplicationTitleComponent(titleComponent);

const connectUrl = import.meta.env.VITE_CONNECT_URL;

if (connectUrl) {
  setSuiteLogoComponent(() => (
    <a
      class="ml-1 flex items-center rounded-l-full bg-neutral-300 pl-3 pr-3 hover:bg-neutral-400 md:ml-6"
      href={connectUrl}
      aria-label="EHA Connect"
    >
      <LogoConnect class="h-10 w-10" background-color="white" foreground-color="#999" />
    </a>
  ));
} else {
  setSuiteLogoComponent(() => (
    <div class="ml-1 flex items-center rounded-l-full bg-neutral-300 pl-3 pr-3 md:ml-6">
      <LogoConnect class="h-10 w-10" background-color="white" foreground-color="#999" />
    </div>
  ));
}

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [{ label: "Home", name: routeNames.home }],
  },
  {
    label: "Form Submissions",
    className: "",
    items: [{ label: "Form Submissions", name: routeNames.formSubmission.formSubmissions }],
  },
  {
    label: "Facilities",
    className: "",
    items: [{ label: "Facilities", name: routeNames.facility.facilities }],
  },
  {
    label: "Wells",
    className: "",
    items: [{ label: "Wells", name: routeNames.well.wells }],
  },
]);
</script>
